import React, {FC, Fragment} from 'react';
import './style.scss';
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import MainRecommendations from "../../containers/Main/RecommendationsPage";
import ForYouContainer from "../../containers/ForYou/ForYouPage";
import MainHeader from "./MainHeader";
import {useHistory} from 'react-router-dom';

interface IMain {
    currentTab: number,
    setCurrentTab: any
}

const Main: FC<IMain> = ({currentTab, setCurrentTab}) => {
    const history = useHistory();

    return (
        <Fragment>
            <MainHeader
                editHandler={() => history.push("/main/change/tastes")}
            />
            <div className="main">
                <Tabs
                    selectedIndex={currentTab} onSelect={tabIndex => setCurrentTab(tabIndex)}
                    className="main__tabs">
                    <TabList className="main__tab-list">
                        <Tab

                            className="main__tab"
                            selectedClassName="main__tab--active"
                        >
                            Рекомендации
                        </Tab>
                        <Tab
                            className="main__tab"
                            selectedClassName="main__tab--active"
                        >
                            Для тебя
                        </Tab>
                    </TabList>
                    <TabPanel>
                        <MainRecommendations/>
                    </TabPanel>
                    <TabPanel>
                        <ForYouContainer/>
                    </TabPanel>
                </Tabs>
            </div>
        </Fragment>
    )
};

export default Main;
